import React from "react";

import { useBrand } from "../../contexts/BrandContext";

/**
 * The muted "you cannot get in right now" box shown wherever a signed-out
 * screen would otherwise offer Sign In / Create Account buttons. Lives here so
 * the closing copy has one home instead of being re-typed at each call site.
 */
export const AccessClosedNote: React.FC = () => {
  const { bookingWindow } = useBrand();

  return (
    <div className="rounded-xl border border-border bg-muted p-4 text-center">
      <p className="text-xs text-muted-foreground">{bookingWindow.message}</p>
    </div>
  );
};

export default AccessClosedNote;
